import { render, staticRenderFns } from "./PageTransitLogin.vue?vue&type=template&id=3a99c96c&scoped=true&"
import script from "./PageTransitLogin.vue?vue&type=script&lang=js&"
export * from "./PageTransitLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a99c96c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a99c96c')) {
      api.createRecord('3a99c96c', component.options)
    } else {
      api.reload('3a99c96c', component.options)
    }
    module.hot.accept("./PageTransitLogin.vue?vue&type=template&id=3a99c96c&scoped=true&", function () {
      api.rerender('3a99c96c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/transitlogin/PageTransitLogin.vue"
export default component.exports